import DetectorInterface from "./DetectorInterface";

export default abstract class Detector implements DetectorInterface {

    public matches: number;
    public misses: number;
    public name: string;
    public min: number | null;
    public max: number | null;

    /**
     * Class constructor
     */
    public constructor(name: string) {
        this.name = name;
        this.matches = 0;
        this.misses = 0;
        this.min = null;
        this.max = null;
    }

    /**
     * Check method is implemented here for all detectors
     *
     * @returns {boolean}
     * @param index
     * @param data
     * @param maxLinesToScan
     */

    public check(index: number, data: Array<any>, maxLinesToScan: number) : void {

        for (let lineNum = 0; lineNum < maxLinesToScan; lineNum++) {

            // If less lines than maxLinesToScan break
            if (typeof data[lineNum] === 'undefined') break;

            const value = typeof data[lineNum][index] !== 'undefined' ? data[lineNum][index] : null;

            if (this.match(value)) {
                this.matches++;

            } else {
                this.misses++;
            }
        }
    }

    /**
     * Get results
     */

    public getResults() : any {
        return {
            class: this.name,
            matches: this.matches,
            misses: this.misses,
            min: this.min,
            max: this.max
        }
    }

    /**
     * Each detector must implement match
     *
     * @param {string} value
     * @returns {boolean}
     */
    public abstract match(value: string) : boolean;
}
